import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const AppLayout = ({ children, isGuest = false }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <div className="app-layout">
      <Sidebar
        collapsed={sidebarCollapsed}
        mobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
        isGuest={isGuest}
      />
      <div className={`main-content${sidebarCollapsed ? ' sidebar-collapsed' : ''}`}>
        <TopBar
          onToggleSidebar={() => setSidebarCollapsed(p => !p)}
          onMobileMenuClick={() => setMobileSidebarOpen(true)}
        />
        <div className="page-content fade-in">
          {children}
        </div>
      </div>
      {mobileSidebarOpen && (
        <div
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 199 }}
          onClick={() => setMobileSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default AppLayout;
